import React from "react";
import Wallet1 from "../../../../Images/book.png"; 
import Wallet from "../../../../Images/coins.png";


const PerformanceSection = () => {
  return (
    <div className="rounded-xl shadow-xl bg-white p-1 sm:h-full h-56 ">
            <h3 className="text-xl font-bold text-slate-800 mb-2">
              Performance
            </h3>

            
            <div className="grid grid-cols-3 gap-1 sm:gap-4 sm:mx-2">
              <div className="flex items-center justify-center gap-2 sm:p-4 rounded-xl bg-bgBlue/5 border-2 border-[#d2b5df]">
                <img src={Wallet} className="hidden sm:block  w-10" />
                <div className="">
                  <p className="text-sm text-slate-500">Total Earning</p>
                  <p className="text-xl font-bold">100 coins</p>
                </div>
              </div>

              <div className="flex items-center justify-center sm:h-24 gap-4 sm:p-2 rounded-xl bg-bgBlue/5 border-2 border-[#d2b5df]">
                <img src={Wallet1} className="hidden sm:block w-10" />
                <div>
                  <p className="text-sm text-slate-500">Question Sloved</p>
                  <p className="text-xl font-bold">120</p>
                </div>
              </div>

              <div className="flex items-center justify-center gap-4 py-4 sm:p-4 rounded-xl bg-bgBlue/5 border-2 border-[#d2b5df]">
                <img src={Wallet} className="hidden sm:block w-10" />
                <div>
                  <p className="text-sm text-slate-500">Quiz Earnings</p>
                  <p className="text-xl font-bold">50 Coins</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-1 sm:gap-4 sm:mx-2 mt-2">
              <div className="flex items-center justify-center gap-2 sm:p-4 rounded-xl bg-bgBlue/5 border-2 border-[#d2b5df]">
                <img src={Wallet} className="hidden sm:block  w-10" />
                <div className="">
                  <p className="text-sm text-slate-500">Total Balance</p>
                  <p className="text-xl font-bold">500 coins</p>
                </div>
              </div>

              <div className="flex items-center justify-center sm:h-24 gap-4 p-2 rounded-xl bg-bgBlue/5 border-2 border-[#d2b5df]">
                <img src={Wallet1} className="hidden sm:block w-10" />
                <div>
                  <p className="text-sm text-slate-500">Contest Sloved</p>
                  <p className="text-xl font-bold">20</p>
                </div>
              </div>

              <div className="flex items-center justify-center gap-4 py-4 px-2 rounded-xl bg-bgBlue/5 border-2 border-[#d2b5df]">
                <img src={Wallet} className="hidden sm:block w-10" />
                <div>
                  <p className="text-sm text-slate-500">Contest Earning</p>
                  <p className="text-xl font-bold">100 Coins</p>
                </div>
              </div>
            </div>

            
          </div>
  );
}

export default PerformanceSection;
